var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLanding2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "landing2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h128v128H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  clipPath: "url(#landing2_svg__a)",
  "data-name": "Group 102"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h128v128H0z",
  "data-name": "Rectangle 65"
}), /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  "data-name": "Group 60"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#051526",
  strokeMiterlimit: 10,
  d: "M91 53V10H38v109h53v-12",
  "data-name": "Path 79"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#051526",
  strokeMiterlimit: 10,
  d: "M45.5 17h40v44h-40z",
  "data-name": "Rectangle 47"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#051526",
  d: "M85 67H45v44h40V93.54",
  "data-name": "Path 105"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#051526",
  strokeMiterlimit: 10,
  d: "M85 52H45",
  "data-name": "Line 7"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#051526",
  strokeMiterlimit: 10,
  "data-name": "Group 57"
}, /*#__PURE__*/React.createElement("path", {
  d: "M85 27.72h-9S73 32 65 32",
  "data-name": "Path 81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 27.72h9S57 32 65 32",
  "data-name": "Path 82"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#051526",
  strokeMiterlimit: 10,
  d: "M52.837 45.177A91 91 0 0 0 65.5 46c8.18 0 15.44-.94 20-2.39",
  "data-name": "Path 83"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#0091ea",
  strokeMiterlimit: 10,
  "data-name": "Group 59",
  transform: "translate(37 9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 16.5,
  r: 16.5,
  "data-name": "Ellipse 14",
  transform: "translate(41.25 55)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 58"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.75 62.75v17.5",
  "data-name": "Line 8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49 71.5h17.5",
  "data-name": "Line 9"
})))))));
export { SvgLanding2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjggMTI4Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjwvY2xpcFBhdGg+PC9kZWZzPjxnIGRhdGEtbmFtZT0iR3JvdXAgMTAyIiBmaWxsPSJub25lIiBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDY1IiBkPSJNMCAwaDEyOHYxMjhIMHoiLz48ZyBkYXRhLW5hbWU9Ikdyb3VwIDYwIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCA3OSIgZD0iTTkxIDUzVjEwSDM4djEwOWg1M3YtMTIiIHN0cm9rZT0iIzA1MTUyNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHBhdGggZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDciIHN0cm9rZT0iIzA1MTUyNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNNDUuNSAxN2g0MHY0NGgtNDB6Ii8+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDEwNSIgZD0iTTg1IDY3SDQ1djQ0aDQwVjkzLjU0IiBzdHJva2U9IiMwNTE1MjYiLz48cGF0aCBkYXRhLW5hbWU9IkxpbmUgNyIgc3Ryb2tlPSIjMDUxNTI2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik04NSA1Mkg0NSIvPjxnIGRhdGEtbmFtZT0iR3JvdXAgNTciIHN0cm9rZT0iIzA1MTUyNiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIj48cGF0aCBkYXRhLW5hbWU9IlBhdGggODEiIGQ9Ik04NSAyNy43MmgtOVM3MyAzMiA2NSAzMiIvPjxwYXRoIGRhdGEtbmFtZT0iUGF0aCA4MiIgZD0iTTQ1IDI3LjcyaDlTNTcgMzIgNjUgMzIiLz48L2c+PHBhdGggZGF0YS1uYW1lPSJQYXRoIDgzIiBkPSJNNTIuODM3IDQ1LjE3N0E5MS4wNTcgOTEuMDU3IDAgMDA2NS41IDQ2YzguMTggMCAxNS40NC0uOTQgMjAtMi4zOSIgc3Ryb2tlPSIjMDUxNTI2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48ZyBkYXRhLW5hbWU9Ikdyb3VwIDU5IiBzdHJva2U9IiMwMDkxZWEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzcgOSkiPjxjaXJjbGUgZGF0YS1uYW1lPSJFbGxpcHNlIDE0IiBjeD0iMTYuNSIgY3k9IjE2LjUiIHI9IjE2LjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQxLjI1IDU1KSIvPjxnIGRhdGEtbmFtZT0iR3JvdXAgNTgiPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA4IiBkPSJNNTcuNzUgNjIuNzV2MTcuNSIvPjxwYXRoIGRhdGEtbmFtZT0iTGluZSA5IiBkPSJNNDkgNzEuNWgxNy41Ii8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";